export const Svg_123 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M35 52.5c-4.715 0-8.75-1.604-12.104-4.812-3.354-3.208-5.152-7.17-5.396-11.886l4.594 1.459c.535 3.11 1.993 5.7 4.375 7.765 2.382 2.066 5.226 3.1 8.531 3.1 3.646 0 6.745-1.277 9.297-3.829 2.552-2.552 3.828-5.65 3.828-9.297 0-3.256-1.033-6.088-3.099-8.494-2.066-2.407-4.654-3.877-7.765-4.412L35.875 17.5c4.667.244 8.605 2.042 11.813 5.396S52.5 30.286 52.5 35c0 4.861-1.701 8.993-5.104 12.396C43.993 50.8 39.861 52.5 35 52.5Zm0 11.667c-4.034 0-7.826-.766-11.375-2.297-3.548-1.531-6.635-3.61-9.26-6.234-2.625-2.625-4.703-5.712-6.234-9.26-1.532-3.55-2.297-7.34-2.297-11.376a23.653 23.653 0 0 1 .146-2.625l4.229 1.313V35c0 6.903 2.406 12.76 7.218 17.573 4.813 4.813 10.67 7.22 17.573 7.22 6.903 0 12.76-2.407 17.573-7.22 4.813-4.812 7.22-10.67 7.22-17.573 0-6.902-2.407-12.76-7.22-17.573C47.761 12.615 41.903 10.21 35 10.21h-1.312l-1.313-4.23A23.872 23.872 0 0 1 35 5.835c4.035 0 7.827.765 11.375 2.297 3.549 1.53 6.636 3.609 9.26 6.234 2.626 2.625 4.704 5.712 6.235 9.26 1.532 3.549 2.297 7.34 2.297 11.375s-.766 7.827-2.297 11.375c-1.531 3.549-3.61 6.636-6.234 9.26-2.625 2.626-5.712 4.704-9.26 6.235-3.55 1.532-7.34 2.297-11.376 2.297ZM30.698 36.46 18.23 23.99 14.584 35 5.834 5.834 35 14.584 23.99 18.23l12.469 12.468-5.76 5.76Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={47.032}
        y1={14.584}
        y2={59.428}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)